// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Addon } from './addon';
import { ProductType } from './product-type';
import { Supplier } from './supplier';

/// <code-import> Place custom imports between <code-import> tags
import { EntityPropertyAnnotation, EntityTypeAnnotation } from '../entity-type-annotations';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PricedAddon extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static getEntityTypeAnnotation(): EntityTypeAnnotation {
    const propAnnotations = [
      new EntityPropertyAnnotation('price', {
        validators: [BaseEntity.notNegativeValidator()],
      }),
      new EntityPropertyAnnotation('accountOwnedPrice', {
        validators: [BaseEntity.notNegativeValidator(true)],
        displayName: 'Inventory Price Override',
      }),
    ];

    return new EntityTypeAnnotation({
      validators: [],
      propertyAnnotations: propAnnotations,
    });
  }

  get inventoryPrice(): number {
    return this.accountOwnedPrice != null ? this.accountOwnedPrice : this.price;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK account */
  accountId!: string;
  /** Decimal */
  accountOwnedPrice?: number;
  /** Guid FK addon */
  addonId!: string;
  /** String(2000) */
  description?: string;
  /** String(100) */
  name!: string;
  /** Decimal */
  price!: number;
  /** Guid FK productType */
  productTypeId!: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplier */
  supplierId!: string;
  /** FK accountId */
  account!: Account;
  /** FK addonId */
  addon!: Addon;
  /** FK productTypeId */
  productType!: ProductType;
  /** FK supplierId */
  supplier!: Supplier;
}

